import { render } from "./EditRetailDetailsDialog.vue?vue&type=template&id=532b5702&scoped=true"
import script from "./EditRetailDetailsDialog.vue?vue&type=script&lang=js"
export * from "./EditRetailDetailsDialog.vue?vue&type=script&lang=js"

import "./EditRetailDetailsDialog.vue?vue&type=style&index=0&id=532b5702&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-532b5702"]])

export default __exports__